import { useContext } from 'react'

import type { AuthContextValue } from '@/providers/auth-types'
import { AuthContext } from '@/providers/authContext'

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}

export const useAuthContext = useAuth
